import { render, staticRenderFns } from "./promoter.vue?vue&type=template&id=0cc74f5a&scoped=true&"
import script from "./promoter.vue?vue&type=script&lang=js&"
export * from "./promoter.vue?vue&type=script&lang=js&"
import style0 from "./promoter.vue?vue&type=style&index=0&id=0cc74f5a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc74f5a",
  null
  
)

export default component.exports